/**
 * Structured client-side logger.
 *
 * Wraps Sentry breadcrumbs + captureMessage for production observability.
 * Only outputs to console in development mode to keep production clean.
 *
 * Usage:
 *   import { logError, logWarn } from "@/lib/client-logger";
 *   logError("upload.failed", { documentId, status: 500 });
 *   logWarn("feature.unavailable", { flagKey: "research_intelligence" });
 */

import * as Sentry from '@sentry/nextjs';

export function logError(message: string, context?: Record<string, unknown>): void {
  if (process.env.NODE_ENV === 'development') {
    console.error(`[ERROR] ${message}`, context);
  }
  Sentry.captureMessage(message, {
    level: 'error',
    extra: context,
  });
}

export function logWarn(message: string, context?: Record<string, unknown>): void {
  if (process.env.NODE_ENV === 'development') {
    console.warn(`[WARN] ${message}`, context);
  }
  Sentry.addBreadcrumb({
    message,
    level: 'warning',
    data: context,
  });
}

export function logInfo(message: string, context?: Record<string, unknown>): void {
  if (process.env.NODE_ENV === 'development') {
    console.info(`[INFO] ${message}`, context);
  }
  Sentry.addBreadcrumb({
    message,
    level: 'info',
    data: context,
  });
}
